import { Type } from "class-transformer";
import { User } from "../auth/user.model";
import { BaseModel } from "../base.model";
import { AlertTypeEnum } from "./contract/alert-contract";

export class Alert extends BaseModel {
  id: number;
  uuid: string;
  type: AlertTypeEnum;
  isClosed: number;
  externalDealId?: string;
  resolvedDate?: number;
  resolvedById?: number;
  @Type(() => User)
  user?: User;
  formInstanceId?: string;
  submissionUUID?: string;

  isOnline: number;
  responseCnt: number;
  get description() {
    let returnValue = "Unknown";
    switch (this.type) {
      case AlertTypeEnum.IncorrectModality:
        returnValue = "Modality missing or invalid. Please correct this in Hubspot";
        break;

      case AlertTypeEnum.ScanBadBarcode:
        returnValue = "Questionnaire response barcode not resolved by ABBYY";
        break;

      case AlertTypeEnum.MissingPractitioner:
        returnValue = "Deal is missing practitioner(s)";
        break;

      case AlertTypeEnum.MissingPrimaryContact:
        returnValue =
          "Deal is missing a primary contact. The survey must have a primary contact added to the deal from Hubspot to progress to the next stage.";
        break;

      case AlertTypeEnum.ImportToNonActiveSurvey:
        returnValue = "New response to closed survey";
        break;

      case AlertTypeEnum.TooManyResponsesImport:
        returnValue = "Paper responses reached expected number";
        break;

      case AlertTypeEnum.ImportResponseOutOfRange:
        returnValue = "Questionnaire response out of range. Please correct ABBYY profile";
        break;
      case AlertTypeEnum.ResponsesReceived50Per:
        returnValue = `Questionnaire received with fewer than 50% responses [${this.isOnline ? "Online" : "Paper"}]`;
        break;
      default:
    }
    return returnValue;
  }

  get ResponseCountForNonActiveAndTooManyResponsesAlert() {
    if (this.type === AlertTypeEnum.ImportToNonActiveSurvey || this.type === AlertTypeEnum.TooManyResponsesImport) {
      return this.responseCnt.toString();
    }
    else {
      return "-";
    }
  }

  get isScannedResponseAlert() {
    return [
      AlertTypeEnum.ScanBadBarcode,
      AlertTypeEnum.ImportToNonActiveSurvey,
      AlertTypeEnum.TooManyResponsesImport,
      AlertTypeEnum.ImportResponseOutOfRange,
      AlertTypeEnum.ResponsesReceived50Per,
    ].includes(this.type);
  }

  get status() {
    return this.isClosed === 1 ? "Closed" : "Open";
  }

  get resolvedByFullName() {
    return this.user ? this.user.contactIdentity : undefined;
  }
}
